<template>
  <div class="container">
    <div class="item">
      <span>手机号码：</span>
      <span>{{currentUser.mobile}}</span>
      <!-- <a href>更换</a> -->
    </div>
    <div class="item">
      <span>所属公司：</span>
      <span>{{companyList.map(v=>v.company).join('/')}}</span>
      <a @click="showFlag = true" href="javascript:void(0);">查看</a>
    </div>
    <div class="item">
      <span>企业微信：</span>
      <span>{{currentUser.wxWork || '暂无信息'}}</span>
    </div>
    <div class="item">
      <span>是否接收周报邮件：</span>
      <el-switch
        style="margin-bottom:4px"
        @change="changeSetting"
        :inactive-value="0"
        :active-value="1"
        v-model="receiveReportEmailFlag"
        active-text="On"
        inactive-text="">
      </el-switch>
    </div>
     <dialog-panel
    :title="'所属公司'"
    :dialogController="showFlag"
    :width="'30%'"
    @cancel="showFlag = false"
    :showCancel="false"
    :showConfirm="false"
    >
      <div class="out-box">
        <div v-for="(item,index) in companyList" :key="index" style="padding:10px 20px" class="flex-box">
          <div>{{item.company}}</div>
          <div>{{item.joinTime||'未知时间'}}加入</div>
        </div>
      </div>
     </dialog-panel>
  </div>
</template>

<script>
import * as api from './api'
export default {
  data(){
    return {
      currentUser:{},
      companyList:[],
      companyNames:'',
      receiveReportEmailFlag:0,
      showFlag:false
    }
  },
  created(){
    this._getPersonalSetting()
  },
  methods:{
    getCompany(){
      this.currentUser = JSON.parse(localStorage.currentUser)
      api.getJoinCompanyTime(this.currentUser.id).then(res=>{
        this.companyList = res.data
      })
    },
    //获取是否接收周报邮件详情
    _getPersonalSetting(){
      api.getPersonalSetting().then((res)=>{
        this.receiveReportEmailFlag = res.data.receiveReportEmailFlag
      })
    },
    /**切换是否接收周报邮件 */
    changeSetting(e){
      let data = {
        receiveReportEmailFlag : e
      }
      api.updatePersonalSetting(data).then(()=>{
        this.$message.success('设置成功')
      })
    }
  },
  mounted(){
    // this.companyList = JSON.parse(localStorage.companyVOList)
    // let list = []
    // this.companyList.forEach(item=>{
    //   list.push(item.name)
    // })
    // this.companyNames = list.join('/')
    this.getCompany()
    // console.log(JSON.parse(localStorage.currentUser),JSON.parse(localStorage.companyVOList))
  }
}
</script>

<style scoped>
.container{
  box-sizing: border-box;
  padding: 8px;
}
.item {
  margin-bottom: 15px;
}
/* span{
    margin-left: 60px;
} */
a{
    margin-left: 100px;
    text-align: right;
}
.out-box{
  max-height: 400px;
  overflow-y: auto;
}
.flex-box{
  display: flex;
}
.flex-box div{
  width: 50%;
}
</style>



// WEBPACK FOOTER //
// src/views/my-workbench/PersonalCenter.vue